"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.drawer.preview': 'Contenuto e Anteprima',
    'socialMediaPlan.drawer.ai': 'Analisi AI',
    'socialMediaPlan.drawer.platforms': 'Piattaforme',
    'socialMediaPlan.drawer.date': 'Data',
    'socialMediaPlan.drawer.type': 'Tipo',
};
